import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Logo,
  Link,
  TextField,
  Button,
  PageSelector,
  ErrorMessage,
  SelectorButtonSection,
  MainFormSection,
  PasswordMessage,
} from '../../components/_layouts/forms/styles';
import { singupRequest, signFailure } from '~/store/modules/auth/actions';

import logo from '../../images/Logo.png';
import Loading from '~/components/Loading';

const validEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function SignUp() {
  const [name, updateName] = useState(null);
  const [email, updateEmail] = useState(null);
  const [password, updatePassword] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const hasError = useSelector((state) => state.auth.hasError);
  const isLoading = useSelector((state) => state.auth.isLoading);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validEmailRegex.test(email)) {
      await dispatch(singupRequest({ name, email, password }));
    } else {
      dispatch(signFailure());
    }
  };

  const handleOnClick = () => history.push('/signin');

  return (
    <>
      <Container>
        <SelectorButtonSection>
          <PageSelector id="not-selected" onClick={() => handleOnClick()}>
            Login
          </PageSelector>
          <PageSelector>Cadastre-se</PageSelector>
        </SelectorButtonSection>

        <MainFormSection>
          <Logo src={logo} alt="Logo tvpersonal" />

          <form onSubmit={(event) => handleSubmit(event)}>
            <TextField
              label="Nome"
              fullWidth
              value={name}
              variant="outlined"
              required
              onChange={(event) => updateName(event.target.value)}
            />

            <TextField
              label="E-mail"
              fullWidth
              value={email}
              variant="outlined"
              required
              onChange={(event) => updateEmail(event.target.value)}
            />

            <TextField
              label="Senha"
              fullWidth
              value={password}
              type="password"
              variant="outlined"
              required
              onChange={(event) => updatePassword(event.target.value)}
            />
            <PasswordMessage>
              A senha deve conter no mínimo 8 dígitos
            </PasswordMessage>

            {hasError ? <ErrorMessage>Dados inválidos!</ErrorMessage> : null}
            <Button
              disabled={isLoading}
              id="create-button"
              fullWidth
              type="submit"
              variant="outlined"
            >
              Cadastrar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </form>

          <Link to="/signin">Voltar para login</Link>
        </MainFormSection>
      </Container>
    </>
  );
}
